export class ClientenFilter {

  static clientnummer(clientnummer: string): ClientenFilter {
    return new ClientenFilter(clientnummer);
  }

  static zoneAndDienst(zoneId: string, dientId: string): ClientenFilter {
    return new ClientenFilter(undefined, zoneId, dientId);
  }

  static clientAchternaam(clientAchternaam: string): ClientenFilter {
    return new ClientenFilter(clientAchternaam);
  }

  constructor(
    private clientnummer?: string,
    private zoneId?: string,
    private dienstId?: string,
    private clientAchternaam?: string,
  ) {
  }

  getClientAchternaam(): string {
    return this.clientAchternaam;
  }

  setClientAchternaam(value: string): void {
    this.zoneId = undefined;
    this.dienstId = undefined;
    this.clientnummer = undefined;
    this.clientAchternaam = value;
  }

  hasClientAchternaam(): boolean {
    return !!this.clientAchternaam;
  }

  getClientnummer(): string {
    return this.clientnummer;
  }

  setClientnummer(value: string): void {
    this.zoneId = undefined;
    this.dienstId = undefined;
    this.clientAchternaam = undefined;
    this.clientnummer = value;
  }

  hasClientnummer(): boolean {
    return !!this.clientnummer;
  }

  getZoneId(): string {
    return this.zoneId;
  }

  setZoneId(value: string): void {
    this.clientnummer = null;
    this.clientAchternaam = undefined;
    this.zoneId = value;
  }

  getDienstId(): string {
    return this.dienstId;
  }

  setDienstId(value: string): void {
    this.clientnummer = null;
    this.dienstId = value;
    this.clientAchternaam = undefined;
  }

  reset(): void {
    this.clientnummer = undefined;
    this.zoneId = undefined;
    this.dienstId = undefined;
    this.clientAchternaam = undefined;
  }

  isAchternaamSearchValid(): boolean {
    if (this.getClientAchternaam()) {
      return this.getClientAchternaam().length >= 2;
    } else {
      return true;
    }
  }
}
